import { render, staticRenderFns } from "./Cartao.vue?vue&type=template&id=4ec5c691"
import script from "./Cartao.vue?vue&type=script&lang=ts"
export * from "./Cartao.vue?vue&type=script&lang=ts"
import style0 from "./Cartao.vue?vue&type=style&index=0&id=4ec5c691&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports